export const NotFoundPage = () => {
  return (
    <>Страница в разработке</>
  )
}